import React, { useEffect, useMemo, useState } from 'react';
import './AdminVendors.css';
import { apiClient, endpoints } from '../api';

const AdminKYCReview = () => {
  // vendor-specific document state removed
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({ vendor: '', document_type: '', status: '', expiry_from: '', expiry_to: '' });
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  // vendor-specific review state removed
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  // Vendor-specific state removed
  const [summary, setSummary] = useState(null);
  const [auditLoading, setAuditLoading] = useState(false);
  const [auditGlobal, setAuditGlobal] = useState([]);
  const [auditTotal, setAuditTotal] = useState(0);
  const [auditFilters, setAuditFilters] = useState({ vendor: '', action: '', admin: '' });
  const [auditPage, setAuditPage] = useState(1);
  // Vendor status update state removed
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalDoc, setModalDoc] = useState(null);
  const [expected, setExpected] = useState({ name: '', pan: '' });
  const [buttonLoading, setButtonLoading] = useState({});
  
  // Sorting & bulk selection state
  const [sortBy, setSortBy] = useState('uploaded_at');
  const [sortDir, setSortDir] = useState('desc');
  const [selectedRows, setSelectedRows] = useState(new Set());

  const adminHeaders = { 'x-admin-key': (window.localStorage.getItem('ADMIN_API_KEY') || 'dev-admin-key') };

  // vendor-specific image display logic removed

  // loadVendors function removed

  // setVendorStatus function removed

  // loadDocs function removed (vendor-specific)

  const openPreviewModal = async (docId) => {
    try {
      // Find in current list instead of docs
      const doc = (list || []).find(d => String(d.id) === String(docId));
      setModalDoc(doc || null);
      setIsModalOpen(true);
    } catch (_) {
      setIsModalOpen(true);
    }
  };

  const closePreviewModal = () => {
    setIsModalOpen(false);
    setModalDoc(null);
  };

  const loadAll = async () => {
    try {
      setLoading(true);
      const params = { ...filters, page, limit };
      const { data } = await apiClient.get(endpoints.adminKycDocuments, { params, headers: adminHeaders });
      let items = data.items || [];
      // Client-side sorting (fallback if backend not providing order)
      items = [...items].sort((a, b) => {
        const dir = sortDir === 'asc' ? 1 : -1;
        const getVal = (row) => {
          if (sortBy === 'uploaded_at') return new Date(row.uploaded_at || 0).getTime();
          if (sortBy === 'expiry_date') return row.expiry_date ? new Date(row.expiry_date).getTime() : 0;
          if (sortBy === 'status') return String(row.doc_status || '');
          return new Date(row.uploaded_at || 0).getTime();
        };
        const va = getVal(a); const vb = getVal(b);
        if (va < vb) return -1 * dir;
        if (va > vb) return 1 * dir;
        return 0;
      });
      setList(items);
      setTotal(Number(data.total || 0));
      // Reset bulk selection on new data
      setSelectedRows(new Set());
    } catch (e) {
      setError('Failed to load KYC documents');
    } finally {
      setLoading(false);
    }
  };

  const loadSummary = async () => {
    try {
      const params = { vendor: filters.vendor, document_type: filters.document_type, status: filters.status, date_from: filters.submitted_from, date_to: filters.submitted_to };
      const { data } = await apiClient.get(endpoints.adminKycSummary, { params, headers: adminHeaders });
      setSummary(data);
    } catch (_) {}
  };

  // loadAudit function removed (vendor-specific)

  const loadAuditGlobal = async () => {
    try {
      setAuditLoading(true);
      const params = { ...auditFilters, page: auditPage, limit: 20 };
      const { data } = await apiClient.get(endpoints.adminKycAudit, { params, headers: adminHeaders });
      setAuditGlobal(data.items || []);
      setAuditTotal(Number(data.total || 0));
    } catch (e) {
      setError('Failed to load audit');
    } finally {
      setAuditLoading(false);
    }
  };

  const runOCR = async (docId) => {
    try {
      const loadingMsg = document.createElement('div');
      loadingMsg.innerHTML = 'OCR processing... This may take a few seconds.';
      loadingMsg.style.cssText = 'position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: #fff; padding: 20px; border: 2px solid #3b82f6; border-radius: 8px; z-index: 10000; box-shadow: 0 4px 6px rgba(0,0,0,0.1);';
      document.body.appendChild(loadingMsg);

      const response = await apiClient.post(endpoints.adminDocOCR(docId), {}, { headers: adminHeaders });
      
      document.body.removeChild(loadingMsg);
      
      if (response.data?.text) {
        alert(`OCR completed successfully! Extracted text preview:\n\n${response.data.text.substring(0, 200)}${response.data.text.length > 200 ? '...' : ''}`);
      } else {
        alert('OCR completed successfully!');
      }
      
      await loadAll();
    } catch (e) {
      // Remove loading message if it exists
      const loadingMsg = document.querySelector('div[style*="OCR processing"]');
      if (loadingMsg) document.body.removeChild(loadingMsg);
      
      console.error('OCR Error:', e);
      const errorMsg = e.response?.data?.error || 'OCR processing failed. Please try again.';
      alert(`OCR Failed: ${errorMsg}`);
    }
  };

  const verifyDoc = async (docId) => {
    try {
      const payload = { expected };
      // Use alias route
      await apiClient.post(endpoints.adminDocVerify(docId), payload, { headers: adminHeaders });
      await loadAll();
    } catch (e) {
      alert('Verification failed');
    }
  };

  const deleteDoc = async (docId) => {
    try {
      const ok = window.confirm('Are you sure you want to delete this document? This action cannot be undone.');
      if (!ok) return;
      
      await apiClient.delete(endpoints.adminDocDelete(docId), { headers: adminHeaders });
      alert('Document deleted successfully!');
      await loadAll();
    } catch (e) {
      console.error('Delete error:', e);
      const errorMsg = e.response?.data?.error || 'Failed to delete document';
      alert('Delete failed: ' + errorMsg);
    }
  };

  // submitReview function removed (vendor-specific)

  const toggleRowSelected = (id) => {
    setSelectedRows(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const toggleAllSelected = () => {
    setSelectedRows(prev => {
      if (prev.size === list.length) return new Set();
      return new Set(list.map(r => r.id));
    });
  };

  const bulkApprove = async () => {
    if (selectedRows.size === 0) return;
    const ok = window.confirm(`Approve ${selectedRows.size} document(s)?`);
    if (!ok) return;
    try {
      for (const id of selectedRows) {
        await apiClient.put(endpoints.adminKycDocumentStatus(id), { status: 'APPROVED' }, { headers: adminHeaders });
      }
      await loadAll();
      alert('Bulk approve completed');
    } catch (_) {
      alert('Bulk approve failed (some items may be processed)');
    }
  };

  const bulkReject = async () => {
    if (selectedRows.size === 0) return;
    const reason = window.prompt(`Enter rejection reason for ${selectedRows.size} document(s):`, '');
    if (reason === null) return;
    try {
      for (const id of selectedRows) {
        await apiClient.post(endpoints.adminDocReject(id), { reason: reason || '' }, { headers: adminHeaders });
      }
      await loadAll();
      alert('Bulk reject completed');
    } catch (_) {
      alert('Bulk reject failed (some items may be processed)');
    }
  };

  useEffect(() => { loadAuditGlobal(); }, [auditFilters.vendor, auditFilters.action, auditFilters.admin, auditPage]);
  useEffect(() => { loadAll(); loadSummary(); }, [filters.vendor, filters.document_type, filters.status, filters.expiry_from, filters.expiry_to, page]);

  return (
    <div className="admin-vendors">
      <div className="admin-vendors-header">
        <div className="admin-vendors-header-content">
          <h1>KYC Review</h1>
          <p>Review vendor documents with OCR highlights</p>
        </div>
      </div>

      {error && <div style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</div>}

      <div className="admin-vendors-filters" style={{ alignItems: 'center' }}>
        <div className="admin-filters-left">
          {/* Vendor selection removed */}
        </div>
        <div className="admin-filters-right" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {/* Vendor status controls removed */}
        </div>
      </div>

          {summary && (
            <>
            <div className="admin-vendors-header" style={{ marginTop: 8 }}>
              <div className="admin-vendors-header-content">
                <h2 style={{ margin: 0 }}>KYC Dashboard Overview</h2>
                <p style={{ margin: 0 }}>Snapshot of KYC progress across vendors</p>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12, marginBottom: 12 }}>
              <div className="admin-card">
                <div className="admin-card-title">Total Vendors</div>
                <div className="admin-card-value">{summary.totalVendors}</div>
              </div>
              <div className="admin-card">
                <div className="admin-card-title">Documents Submitted</div>
                <div className="admin-card-value">{summary.totalDocuments}</div>
              </div>
              <div className="admin-card">
                <div className="admin-card-title">Verified Documents</div>
                <div className="admin-card-value">{summary.verifiedDocuments}</div>
              </div>
              <div className="admin-card">
                <div className="admin-card-title">Pending Verification</div>
                <div className="admin-card-value">{summary.pendingVerification}</div>
              </div>
              <div className="admin-card">
                <div className="admin-card-title">Rejected Documents</div>
                <div className="admin-card-value">{summary.rejectedDocuments}</div>
              </div>
            </div>
            </>
          )}
          {summary && (
            <div className="admin-card" style={{ marginBottom: 12 }}>
              <div className="admin-card-title">Expiring Alerts (by retention)</div>
              <div style={{ display: 'flex', gap: 16 }}>
                <span>30d: {summary.expiring?.days30 || 0}</span>
                <span>60d: {summary.expiring?.days60 || 0}</span>
                <span>90d: {summary.expiring?.days90 || 0}</span>
              </div>
            </div>
          )}
          <div className="admin-vendors-table-container">
          <div style={{ marginTop: 16 }}>
            <h3>All KYC Documents</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 8, marginBottom: 8 }}>
              <input className="admin-search-input" placeholder="Filter by vendor" value={filters.vendor} onChange={(e) => { setPage(1); setFilters({ ...filters, vendor: e.target.value }); }} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <select className="admin-search-input" value={filters.document_type} onChange={(e) => { setPage(1); setFilters({ ...filters, document_type: e.target.value }); }}>
                  <option value="">All Types</option>
                  <option value="gst">GST</option>
                  <option value="pan">PAN</option>
                  <option value="fssai">FSSAI</option>
                  <option value="shopLicense">Shop License</option>
                  <option value="aadhaar">Aadhaar</option>
                  <option value="bankProof">Bank Proof</option>
                </select>
                <select className="admin-search-input" value={filters.status} onChange={(e) => { setPage(1); setFilters({ ...filters, status: e.target.value }); }}>
                  <option value="">All Status</option>
                  {['UPLOADED','OCR_CHECK','FLAGGED','MANUAL_REVIEW','APPROVED','REJECTED'].map(s => (<option key={s} value={s}>{s}</option>))}
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <select className="admin-search-input" value={filters.verification_status || ''} onChange={(e) => { setPage(1); setFilters({ ...filters, verification_status: e.target.value }); }}>
                  <option value="">Verification: All</option>
                  <option value="PENDING">Pending</option>
                  <option value="VERIFIED">Verified</option>
                  <option value="REJECTED">Rejected</option>
                </select>
                {/* Sorting controls */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  <select className="admin-search-input" value={sortBy} onChange={(e) => { setSortBy(e.target.value); }}>
                    <option value="uploaded_at">Sort by Submitted Date</option>
                    <option value="expiry_date">Sort by Expiry Date</option>
                    <option value="status">Sort by Status</option>
                  </select>
                  <select className="admin-search-input" value={sortDir} onChange={(e) => { setSortDir(e.target.value); }}>
                    <option value="asc">Asc</option>
                    <option value="desc">Desc</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <input type="date" className="admin-search-input" value={filters.submitted_from || ''} onChange={(e) => { setPage(1); setFilters({ ...filters, submitted_from: e.target.value }); }} />
                <input type="date" className="admin-search-input" value={filters.submitted_to || ''} onChange={(e) => { setPage(1); setFilters({ ...filters, submitted_to: e.target.value }); }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <button className="btn btn-secondary" onClick={toggleAllSelected}>{selectedRows.size === list.length && list.length > 0 ? 'Unselect All' : 'Select All'}</button>
              <button className="btn btn-primary" onClick={bulkApprove} disabled={selectedRows.size === 0}>Bulk Approve</button>
              <button className="btn btn-secondary" onClick={bulkReject} disabled={selectedRows.size === 0}>Bulk Reject</button>
            </div>
            <table className="admin-vendors-table">
              <thead>
                <tr>
                  <th style={{ width: 36 }}></th>
                  <th>Vendor</th>
                  <th>Vendor ID / Name</th>
                  <th>Document Type</th>
                  <th>Document Number</th>
                  <th>Submitted Date/Time</th>
                  <th>Status</th>
                  <th>Verified By</th>
                  <th>Expiry Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && <tr><td colSpan={10} style={{ padding: 12 }}>Loading…</td></tr>}
                {!loading && list.map(row => (
                  <tr key={row.id} onClick={() => openPreviewModal(row.id)} style={{ cursor: 'pointer' }}>
                    <td onClick={(e) => { e.stopPropagation(); toggleRowSelected(row.id); }}>
                      <input type="checkbox" checked={selectedRows.has(row.id)} onChange={() => {}} />
                    </td>
                    <td>{row.vendor_name}</td>
                    <td>#{row.vendor_id} / {row.vendor_name}</td>
                    <td>{row.document_type}</td>
                    <td>{row.document_number || '-'}</td>
                    <td>{new Date(row.uploaded_at).toLocaleString()}</td>
                    <td><span className={`admin-status-badge ${String(row.doc_status||'').toLowerCase()}`}>{row.doc_status}</span></td>
                    <td>{row.verified_by || '-'}</td>
                    <td>{row.expiry_date ? new Date(row.expiry_date).toLocaleDateString() : '-'}</td>
                    <td style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-secondary kyc-approve-btn" onClick={async (e) => { 
                        e.stopPropagation(); 
                        const ok = window.confirm('Approve this document? This will mark it as VERIFIED.'); 
                        if (!ok) return; 
                        try {
                          await apiClient.put(endpoints.adminKycDocumentStatus(row.id), { status: 'APPROVED' }, { headers: adminHeaders }); 
                          alert('Document approved successfully!');
                          loadAll(); 
                        } catch (error) {
                          console.error('Approval error:', error);
                          const errorMsg = error.response?.data?.error || 'Unknown error';
                          
                          // If it's a transition error, try the direct approve endpoint
                          if (errorMsg.includes('Invalid transition')) {
                            try {
                              await apiClient.post(endpoints.adminDocApprove(row.id), { notes: 'Approved' }, { headers: adminHeaders });
                              alert('Document approved successfully!');
                              loadAll();
                            } catch (fallbackError) {
                              console.error('Fallback approval error:', fallbackError);
                              alert('Failed to approve document: ' + (fallbackError.response?.data?.error || 'Unknown error'));
                            }
                          } else {
                            alert('Failed to approve document: ' + errorMsg);
                          }
                        }
                      }}>Approve</button>
                      <button className="btn btn-secondary kyc-reject-btn" onClick={async (e) => { 
                        e.stopPropagation(); 
                        const reason = window.prompt('Enter rejection reason (optional):', ''); 
                        if (reason === null) return; // User cancelled
                        try {
                          await apiClient.post(endpoints.adminDocReject(row.id), { reason: reason || '' }, { headers: adminHeaders }); 
                          alert('Document rejected successfully!');
                          loadAll(); 
                        } catch (error) {
                          console.error('Rejection error:', error);
                          const errorMsg = error.response?.data?.error || 'Unknown error';
                          
                          // If it's a transition error, try the status update endpoint
                          if (errorMsg.includes('Invalid transition')) {
                            try {
                              await apiClient.put(endpoints.adminKycDocumentStatus(row.id), { status: 'REJECTED', notes: reason || '' }, { headers: adminHeaders });
                              alert('Document rejected successfully!');
                              loadAll();
                            } catch (fallbackError) {
                              console.error('Fallback rejection error:', fallbackError);
                              alert('Failed to reject document: ' + (fallbackError.response?.data?.error || 'Unknown error'));
                            }
                          } else {
                            alert('Failed to reject document: ' + errorMsg);
                          }
                        }
                      }}>Reject</button>
                      <button className="btn btn-secondary kyc-download-btn" onClick={(e) => { 
                        e.stopPropagation(); 
                        (async () => { 
                          try { 
                            const response = await apiClient.get(endpoints.adminKycDownload(row.id), { headers: adminHeaders, responseType: 'blob' }); 
                            const url = window.URL.createObjectURL(new Blob([response.data])); 
                            const link = document.createElement('a'); 
                            link.href = url; 
                            link.setAttribute('download', row.original_name || `${row.document_type}-${row.id}`); 
                            document.body.appendChild(link); 
                            link.click(); 
                            link.remove(); 
                            window.URL.revokeObjectURL(url); // Clean up memory
                          } catch (error) { 
                            console.error('Download error:', error);
                            alert('Download failed: ' + (error.response?.data?.error || 'File not found or network error')); 
                          } 
                        })(); 
                      }}>Download</button>
                      <button className="btn btn-secondary kyc-ocr-btn" onClick={(e) => { e.stopPropagation(); runOCR(row.id); }}>OCR</button>
                      <button className="btn btn-secondary kyc-delete-btn" onClick={(e) => { e.stopPropagation(); deleteDoc(row.id); }}>DELETE</button>
                      <button className="btn btn-secondary kyc-verify-btn" onClick={async (e) => { e.stopPropagation(); const ok = window.confirm('Confirm verification using the Expected Fields on the right panel?'); if (!ok) return; await verifyDoc(row.id); }}>Verify</button>
                    </td>
                  </tr>
                ))}
                {!loading && list.length === 0 && (
                  <tr><td colSpan={10} style={{ padding: 12 }}>No documents</td></tr>
                )}
              </tbody>
            </table>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
              <div style={{ fontSize: 12, color: '#64748b' }}>Total: {total}</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-secondary" disabled={page <= 1} onClick={() => setPage(p => Math.max(1, p - 1))}>Prev</button>
                <span style={{ alignSelf: 'center' }}>Page {page}</span>
                <button className="btn btn-secondary" disabled={(page * limit) >= total} onClick={() => setPage(p => p + 1)}>Next</button>
              </div>
            </div>
          </div>
            <h3 style={{ marginTop: 16 }}>Global Audit (searchable)</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 8 }}>
              <input className="admin-search-input" placeholder="Vendor or ID" value={auditFilters.vendor} onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, vendor: e.target.value }); }} />
              <input className="admin-search-input" placeholder="Action (approve/reject/ocr/verify/notify)" value={auditFilters.action} onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, action: e.target.value }); }} />
              <input className="admin-search-input" placeholder="Admin ID" value={auditFilters.admin} onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, admin: e.target.value }); }} />
            </div>
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, maxHeight: 240, overflow: 'auto' }}>
              <table className="admin-vendors-table" style={{ margin: 0 }}>
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Vendor</th>
                    <th>Doc</th>
                    <th>Action</th>
                    <th>Admin</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {auditLoading && <tr><td colSpan={6} style={{ padding: 8 }}>Loading…</td></tr>}
                  {!auditLoading && auditGlobal.map(r => (
                    <tr key={r.id}>
                      <td>{new Date(r.created_at).toLocaleString()}</td>
                      <td>{r.vendor_name || r.vendor_id}</td>
                      <td>{r.document_type || '-'} {r.original_name ? `(${r.original_name})` : ''}</td>
                      <td>{r.action}</td>
                      <td>{r.admin_identifier || '-'}</td>
                      <td>{r.notes || ''}</td>
                    </tr>
                  ))}
                  {!auditLoading && auditGlobal.length === 0 && <tr><td colSpan={6} style={{ padding: 8 }}>No results</td></tr>}
                </tbody>
              </table>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
              <div style={{ fontSize: 12, color: '#64748b' }}>Total: {auditTotal}</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-secondary" disabled={auditPage <= 1} onClick={() => setAuditPage(p => Math.max(1, p - 1))}>Prev</button>
                <span style={{ alignSelf: 'center' }}>Page {auditPage}</span>
                <button className="btn btn-secondary" disabled={(auditPage * 20) >= auditTotal} onClick={() => setAuditPage(p => p + 1)}>Next</button>
              </div>
            </div>
          </div>

      {isModalOpen && (
        <div className="admin-modal-overlay" onClick={closePreviewModal}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()} style={{ width: 960, maxWidth: '96vw' }}>
            <div className="admin-modal-header">
              <h3 style={{ margin: 0 }}>Document Preview</h3>
              <button className="btn btn-secondary" onClick={closePreviewModal}>Close</button>
            </div>
            <div className="admin-modal-body" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div>
                {(() => {
                  const d = modalDoc || selected;
                  if (!d) return <div>No document</div>;
                  const mime = String(d.mime_type || '').toLowerCase();
                  const path = d.file_path ? `/${String(d.file_path).replace('\\','/')}` : '';
                  if (mime.startsWith('image/')) {
                    return (
                      <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                        <img src={path} alt="Preview" style={{ width: '100%', display: 'block' }} />
                      </div>
                    );
                  }
                  return <iframe title="preview" src={path} style={{ width: '100%', height: 500, border: '1px solid #e5e7eb', borderRadius: 8 }} />
                })()}
                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                  <button className="btn btn-secondary kyc-ocr-btn" onClick={() => modalDoc && runOCR(modalDoc.id)}>OCR</button>
                  <button className="btn btn-secondary kyc-delete-btn" onClick={() => modalDoc && deleteDoc(modalDoc.id)}>DELETE</button>
                  <button className="btn btn-secondary kyc-download-btn" onClick={async () => {
                    try {
                      if (!modalDoc) return;
                      const response = await apiClient.get(endpoints.adminKycDownload(modalDoc.id), { headers: adminHeaders, responseType: 'blob' });
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', modalDoc.original_name || `${modalDoc.original_name}-${modalDoc.id}`);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      window.URL.revokeObjectURL(url); // Clean up memory
                    } catch (error) { 
                      console.error('Download error:', error);
                      alert('Download failed: ' + (error.response?.data?.error || 'File not found or network error')); 
                    }
                  }}>Download</button>
                </div>
              </div>
              <div>
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontWeight: 600 }}>{modalDoc?.document_type?.toUpperCase()} #{modalDoc?.id}</div>
                  <div style={{ color: '#64748b', fontSize: 12 }}>{new Date(modalDoc?.uploaded_at || Date.now()).toLocaleString()}</div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                  <div>
                    <div style={{ fontSize: 12, color: '#64748b' }}>Status</div>
                    <div>{modalDoc?.doc_status || 'UPLOADED'}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 12, color: '#64748b' }}>Verified By</div>
                    <div>{modalDoc?.verified_by || '-'}</div>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                  <input className="admin-search-input" placeholder="Expected Name" value={expected.name} onChange={e => setExpected({ ...expected, name: e.target.value })} />
                  <input className="admin-search-input" placeholder="Expected Number" value={expected.pan} onChange={e => setExpected({ ...expected, pan: e.target.value })} />
                </div>
                <div className="admin-modal-actions">
                  <button className="btn btn-primary kyc-approve-btn" onClick={async () => {
                    if (!modalDoc) return;
                    const ok = window.confirm('Approve this document?');
                    if (!ok) return;
                    try {
                      await apiClient.post(endpoints.adminDocApprove(modalDoc.id), { notes: 'Approved' }, { headers: adminHeaders });
                      alert('Document approved successfully!');
                      await loadAll();
                      closePreviewModal();
                    } catch (error) {
                      console.error('Approval error:', error);
                      const errorMsg = error.response?.data?.error || 'Unknown error';
                      
                      // If it's a transition error, try the status update endpoint
                      if (errorMsg.includes('Invalid transition')) {
                        try {
                          await apiClient.put(endpoints.adminKycDocumentStatus(modalDoc.id), { status: 'APPROVED' }, { headers: adminHeaders });
                          alert('Document approved successfully!');
                          await loadAll();
                          closePreviewModal();
                        } catch (fallbackError) {
                          console.error('Fallback approval error:', fallbackError);
                          alert('Failed to approve document: ' + (fallbackError.response?.data?.error || 'Unknown error'));
                        }
                      } else {
                        alert('Failed to approve document: ' + errorMsg);
                      }
                    }
                  }}>Approve</button>
                  <button className="btn btn-secondary kyc-reject-btn" onClick={async () => {
                    if (!modalDoc) return;
                    const reason = window.prompt('Enter rejection reason (optional):', '');
                    if (reason === null) return; // User cancelled
                    try {
                      await apiClient.post(endpoints.adminDocReject(modalDoc.id), { reason: reason || '' }, { headers: adminHeaders });
                      alert('Document rejected successfully!');
                      await loadAll();
                      closePreviewModal();
                    } catch (error) {
                      console.error('Rejection error:', error);
                      const errorMsg = error.response?.data?.error || 'Unknown error';
                      
                      // If it's a transition error, try the status update endpoint
                      if (errorMsg.includes('Invalid transition')) {
                        try {
                          await apiClient.put(endpoints.adminKycDocumentStatus(modalDoc.id), { status: 'REJECTED', notes: reason || '' }, { headers: adminHeaders });
                          alert('Document rejected successfully!');
                          await loadAll();
                          closePreviewModal();
                        } catch (fallbackError) {
                          console.error('Fallback rejection error:', fallbackError);
                          alert('Failed to reject document: ' + (fallbackError.response?.data?.error || 'Unknown error'));
                        }
                      } else {
                        alert('Failed to reject document: ' + errorMsg);
                      }
                    }
                  }}>Reject</button>
                  <button className="btn kyc-verify-btn" onClick={async () => {
                    if (!modalDoc) return;
                    const ok = window.confirm('Verify using expected fields?');
                    if (!ok) return;
                    await verifyDoc(modalDoc.id);
                    await loadAll();
                  }}>Verify</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminKYCReview;


